/**
 * 术语表处理器模块
 * 提供术语表的预处理和后处理功能，用于在翻译过程中保持术语一致性
 */

import { createGlossaryProcessor, GlossaryProcessor } from './glossaryProcessor'
import { GlossaryHelperTypes } from './types'
import { normalizeTermText, validateGlossaryData } from './utils'

// 导出类型定义
export { GlossaryHelperTypes } from './types'

// 导出核心处理器
export { GlossaryProcessor, createGlossaryProcessor } from './glossaryProcessor'

// 导出工具函数
export {
  generatePlaceholder,
  parsePlaceholder,
  validateGlossaryData,
  createTermRegex,
  detectTermConflicts,
  normalizeTermText,
  findAllPlaceholders,
} from './utils'

// 导出便捷的静态方法
export class GlossaryHelper {
  processor: GlossaryProcessor

  constructor() {
    this.processor = createGlossaryProcessor()
  }

  /**
   * 快速预处理文本（使用默认配置）
   * @param text 原始文本
   * @param glossaryList 术语表列表
   * @param fromLang 源语言
   * @param toLang 目标语言
   * @returns 预处理结果
   */
  preprocessText(
    text: string,
    glossaryList: GlossaryHelperTypes.GlossaryData[]
  ): GlossaryHelperTypes.PreprocessResult {
    const processor = this.processor
    return processor.preprocessText(text, glossaryList)
  }

  /**
   * 快速后处理文本（使用默认配置）
   * @param translatedText 翻译后的文本
   * @param preprocessResult 预处理结果
   * @returns 后处理结果
   */
  postprocessText(
    translatedText: string,
    preprocessResult: GlossaryHelperTypes.PreprocessResult
  ): GlossaryHelperTypes.PostprocessResult {
    const processor = this.processor
    return processor.postprocessText(translatedText, preprocessResult)
  }

  /**
   * 验证术语表数据格式
   * @param glossaryData 术语表数据
   * @returns 验证结果
   */
  validateGlossary(glossaryData: GlossaryHelperTypes.GlossaryData): {
    valid: boolean
    errors: string[]
  } {
    return validateGlossaryData(glossaryData)
  }
}

const glossaryHelper = new GlossaryHelper()

// 默认导出术语表助手类
export default glossaryHelper
